var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bank-card-2-line") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Zeplin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Funds---New-Deposit-Praxis---Desktop---Selection",
    transform: "translate(-332.000000, -340.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(292.000000, 340.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bank-card-2-line",
    transform: "translate(40.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 32 0 32 32 0 32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,4 L28,4 C28.7363797,4 29.3333333,4.59695367 29.3333333,5.33333333 L29.3333333,26.6666667 C29.3333333,27.4030463 28.7363797,28 28,28 L4,28 C3.26362033,28 2.66666667,27.4030463 2.66666667,26.6666667 L2.66666667,5.33333333 C2.66666667,4.59695367 3.26362033,4 4,4 Z M26.6666667,16 L5.33333333,16 L5.33333333,25.3333333 L26.6666667,25.3333333 L26.6666667,16 Z M26.6666667,10.6666667 L26.6666667,6.66666667 L5.33333333,6.66666667 L5.33333333,10.6666667 L26.6666667,10.6666667 Z",
    id: "Shape",
    fill: "#138518",
    fillRule: "nonzero"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankCard);
export default __webpack_public_path__ + "static/media/bank-card.357c99d0.svg";
export { ForwardRef as ReactComponent };